module.exports = __webpack_public_path__ + "static/media/swscrc5-3.f43ffca9.mp3";